import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Toolbar,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import HouseIcon from '@mui/icons-material/House';
import ListAltIcon from '@mui/icons-material/ListAlt';
import HandshakeIcon from '@mui/icons-material/Handshake';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useLocation, useNavigate } from 'react-router';
import { appPaths } from '../app-paths';
import { useAuth } from '@dwelvio/auth-react';
import { IUserData } from '../types';
interface MainNavbarProps {
  onDrawerClose: () => void;
  drawerIsOpen: boolean;
}

const NavigationMenu = ({ direction }: { direction: 'row' | 'column' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth<IUserData>();

  const navList = React.useMemo(() => {
    return [
      { path: appPaths.unitList.navigate(), label: 'Nehnuteľnosti', icon: <HouseIcon /> },
      { path: appPaths.contractList.navigate(), label: 'Prenájmy', icon: <HandshakeIcon /> },
      { path: appPaths.invoiceList.navigate(), label: 'Faktúry', icon: <ReceiptIcon /> },
      { path: appPaths.expenseList.navigate(), label: 'Výdavky', icon: <ShoppingCartIcon /> },
      { path: appPaths.moneyTransactionList.navigate(), label: 'Peniaze', icon: <AccountBalanceWalletIcon /> },
      { path: appPaths.taskList.navigate(), label: 'Úlohy', icon: <ListAltIcon /> },
    ];
  }, [location.pathname]);

  return (
    <List sx={{ display: 'flex', flexDirection: direction, width: '100%' }}>
      {navList.map((item) => (
        <ListItem key={item.path} disablePadding>
          <ListItemButton
            onClick={() => navigate(item.path)}
            sx={{ px: 3, py: 1 }}
            selected={
              (item.path === '/' && location.pathname === '/') ||
              (item.path !== '/' && location.pathname.startsWith(item.path))
            }
          >
            <ListItemIcon sx={{ minWidth: '2.5em' }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export function MainNavbar(props: MainNavbarProps) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return isDesktop ? (
    <Paper
      sx={{ width: '100%', borderWidth: 0, borderRightWidth: 1, height: 'auto', position: 'relative' }}
      square
      variant="outlined"
    >
      <NavigationMenu direction="row" />
    </Paper>
  ) : (
    <Drawer
      variant="temporary"
      open={props.drawerIsOpen}
      onClose={props.onDrawerClose}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
    >
      <Toolbar variant="dense" />
      <NavigationMenu direction="column" />
    </Drawer>
  );
}
